/**
 * Site-level constants, deliberately in their own module.
 *
 * These used to live in `articles.js`, which imports the full ~197 kB content
 * bundle. Anything in the main chunk that needed the origin therefore pulled every
 * article in with it and undid the code splitting: the main bundle went from
 * 365 kB to 424 kB the moment pageSeo.js imported from there. Keep this file free
 * of any import that is not itself tiny.
 */

export const SITE_ORIGIN = 'https://mixtapememories.app';
